import appConfig from 'app-config';
import { MLReadableErrorUtil, MLNotificationBlockUtil } from 'ml-portals-util-react';
import _ from 'lodash';

function MLExceptionErrorHandler() {
    const { errorCodes } = appConfig;

    const { replaceUnreadableError } = MLReadableErrorUtil();
    const {
        clearBlockAlerts,
        addErrorAlert,
    } = MLNotificationBlockUtil();

    const parseParamsFromBaseErrorString = (baseErrorString) => {
        let uwIssues = [];

        let messageString;
        let stackTraceString;
        let formattedStackTraceString;
        let displayableErrorMessages = [];

        if (!baseErrorString) {
            return {};
        }

        // Split strings into before and after stack trace
        const indexOfStackTrace = baseErrorString ? baseErrorString.indexOf('StackTrace_ML') : -1;
        const indexOfMessages = baseErrorString ? baseErrorString.indexOf('Messages_ML') : -1;

        if (indexOfStackTrace !== -1) {
            stackTraceString = baseErrorString.substring(indexOfStackTrace);
        }

        if (indexOfMessages !== -1) {
            messageString = baseErrorString.substring(0, indexOfMessages);
        } else if (indexOfStackTrace !== -1) {
            messageString = baseErrorString.substring(0, indexOfStackTrace);
        } else {
            messageString = baseErrorString || '';
        }

        const errorMessageStringArray = messageString.split(' ');
        const outerErrorCodeIndex = messageString.indexOf('ErrorCode:');
        const outerErrorCodeValue = outerErrorCodeIndex !== -1 ? errorMessageStringArray[outerErrorCodeIndex + 1] : undefined;
        const outerErrorCodeNumericValue = !_.isUndefined(outerErrorCodeValue) ? parseInt(outerErrorCodeValue, 10) : undefined;

        const innerErrorCodeIndex = errorMessageStringArray.lastIndexOf('ErrorCode:');
        const innerErrorCodeValue = innerErrorCodeIndex !== -1 ? errorMessageStringArray[innerErrorCodeIndex + 1] : undefined;
        const innerErrorCodeNumericValue = !_.isUndefined(innerErrorCodeValue) ? parseInt(innerErrorCodeValue, 10) : undefined


        // Get UW Issues
        if (outerErrorCodeNumericValue === errorCodes.APPLICATION_ERROR_ML && messageString.indexOf('|') !== -1) {
            const errorMsgsByNewLine = messageString.split('|');
            const uwIssuesArrayNonFormatted = errorMsgsByNewLine.splice(1);

            uwIssues = uwIssuesArrayNonFormatted.map((uwIssueStr) => {
                // UWIssues in format of code_ML:{code};LongDescription:{desc};|
                if (uwIssueStr.includes('Code_ML') && uwIssueStr.includes('LongDescription')) {
                    const uwIssuesStringArray = uwIssueStr.split(';');

                    return {
                        code_ML: uwIssuesStringArray[1],
                        longDescription: uwIssuesStringArray[3]
                    };
                }
            })
        } else if (outerErrorCodeNumericValue === errorCodes.DISPLAYABLE_ERROR_ML && baseErrorString.indexOf('|Declined:') !== -1) {
            const messagesML = baseErrorString.match(new RegExp("Messages_ML\: \\[(.*)\\]"));
            const messagesSplit = messagesML[1].split("|");

            displayableErrorMessages = messagesSplit;
        } else {
            const indexOfMessageSplit = messageString.indexOf('|');

            if (indexOfMessageSplit !== -1) {
                const fullErrorMessageString = messageString.substring(0, indexOfMessageSplit);
                const errorMessageSplit = fullErrorMessageString.split('ErrorMessage:');

                if (errorMessageSplit.length > 0) {
                    const readableErrorMessages = errorMessageSplit.map((message) => replaceUnreadableError(message));

                    displayableErrorMessages = [readableErrorMessages[1]];
                }
            } else {
                try {
                    displayableErrorMessages = messageString.split('ErrorMessage:')
                        .filter((msg) => !msg.includes("ErrorCode:"))
                        .map((msg) => {
                            const idx = msg.indexOf("ExceptionML:");

                            if (idx > -1) {
                                return msg.substring(idx).replace("ExceptionML:", "").trim();
                            }

                            return msg;
                        });
                } catch (e) {

                    console.error(e);
                    displayableErrorMessages = [];
                }
            }
        }

        if (stackTraceString) {
            const startIndexOfStackTrace = stackTraceString.indexOf(':');

            formattedStackTraceString = stackTraceString.substring(startIndexOfStackTrace + 1);
        }

        return {
            outerErrorCode: outerErrorCodeNumericValue,
            innerErrorCode: innerErrorCodeNumericValue,
            uwIssues,
            formattedStackTraceString,
            displayableErrorMessages
        }
    };


    const handleExceptionErrors = (error , shouldAddAlerts = true) => {
        const { baseError } = error;

        clearBlockAlerts('APIErrors')

        if (baseError) {
            const formattedError = parseParamsFromBaseErrorString(baseError);
            const errorMessages = formattedError.displayableErrorMessages

            if(!shouldAddAlerts){
                return errorMessages
            }

            if (!_.isEmpty(errorMessages)) {

                errorMessages.forEach((err) => {
                    addErrorAlert(err, 'APIErrors')
                })

            }
        }

        return null
    }

    const clearExceptionErrors = () => {
        clearBlockAlerts('APIErrors')
    }

    return {
        handleExceptionErrors,
        clearExceptionErrors
    }

}

export default MLExceptionErrorHandler